export default "__VITE_ASSET__Cscp1h4s__"